exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-viewer .overlay {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: rgba(0, 0, 0, 0.75);\n  z-index: 9;\n}\n.image-viewer .lightbox {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 10;\n}\n.image-viewer .lightbox img {\n  width: calc(100% - 24px);\n  height: auto;\n}", ""]);

// exports
